<div class="container pt-4 text-center">
    <p>Here is a main page of Callan Video Classroom</p>
    <button class="btn btn-lg btn-primary" routerLink="/manager/profiles">Enter Here</button>
</div>
